import classNames from 'classnames';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeCartItem } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

import ExtendedPrice from './components/ExtendedPrice';
import GiftCardItemData from './components/GiftCardItemData';
import Image from './components/Image';
import ItemPrice from './components/ItemPrice';
import QuantityEditable from './components/QuantityEditable';
import Title from './components/Title';

const ItemEditable = (props) => {
  const { item } = props;
  const { t } = useLocalization();
  const [isQuantityUpdating, setIsQuantityUpdating] = useState(false);
  const [isItemRemoving, setIsItemRemoving] = useState(false);
  const cartReducer = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const { skuBeingAdded } = cartReducer;

  const handleRemove = () => {
    let useLoyaltyPoints = false;
    if (item.itemData?.useLoyaltyPoints) {
      useLoyaltyPoints = true;
    }
    setIsItemRemoving(true);
    const onSuccess = () => {
      // TODO - throws an error - ask Tyson about best way to do this
      // setIsItemRemoving(false);
    };
    const onError = () => {
      setIsItemRemoving(false);
    };
    dispatch(removeCartItem(item.id, useLoyaltyPoints, onSuccess, onError));
  };

  const onIsQuantityUpdating = (isUpdating) => {
    setIsQuantityUpdating(isUpdating);
  };

  // TODO gift cards and other errors
  const isUpdating = skuBeingAdded === item.sku || isQuantityUpdating;
  const isGiftCard = item.type === 'Gift Card' && item.itemData;
  return (
    <>
      <li
        className={classNames(
          'c7-order-item',
          isGiftCard && 'c7-order-item--giftcard',
          isItemRemoving && 'c7-loading--overlay'
        )}
        role="group"
        aria-label={t('general.accessibility.product')}
      >
        {isItemRemoving && (
          <div className="c7-spinner" role="status" aria-live="polite">
            <span className="c7-sr-only">
              {t('general.accessibility.loading')}
            </span>
          </div>
        )}
        <Image item={item} />
        <div className="c7-order-item__details">
          <Title item={item} />
          <button
            className="c7-link"
            type="button"
            onClick={handleRemove}
            disabled={isItemRemoving}
          >
            <span>{t('general.common.remove')}</span>
          </button>
        </div>
        <div className="c7-order-item__pricing">
          <ItemPrice item={item} />
          <QuantityEditable
            item={item}
            isGiftCard={isGiftCard}
            onIsQuantityUpdating={onIsQuantityUpdating}
          />
          {/* {isGiftCard && ()} */}
          <ExtendedPrice item={item} isQuantityUpdating={isUpdating} />
        </div>
        <GiftCardItemData item={item} />
      </li>

      {/* this is the old code <div>
        <div className="c7-order-item__quantity">
          {error && (
            <span className="c7-product__error" aria-describedby="qtyerror">
              Error: {error}
            </span>
          )}
          <Quantity
            item={item}
            describedby={describedby}
            onError={this.handleError}
          />
        </div>
        <div className="c7-order-item__title">
          <EventItemData item={item} />
          <GiftCardItemData item={item} />
        </div>
        <ItemPrice item={item} settings={settings} />
        <div className="c7-order-item__item-total">
          {currencyFormat(item.price * item.quantity, settings)}
          <Points item={item} />
        </div>
      </div> */}
    </>
  );
};

export default ItemEditable;
